// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"8d66d614","453":"2cb262cd","553":"76c9cef2"}[chunkId] + ".chunk.js";
};